import { render, staticRenderFns } from "./PowerDetail.vue?vue&type=template&id=2c1e2efa&scoped=true&"
import script from "./PowerDetail.vue?vue&type=script&lang=js&"
export * from "./PowerDetail.vue?vue&type=script&lang=js&"
import style0 from "./PowerDetail.vue?vue&type=style&index=0&id=2c1e2efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1e2efa",
  null
  
)

export default component.exports